<div class="popup-container">
    <h2>Additional Work</h2>
    <form>
      <div *ngFor="let item of items" style="padding-bottom: 1em;">
        <mat-checkbox style="padding: 0.5em;
        font-size: 1.25em;" (change)="toggleItem(item, $event.checked)"
        [checked]="isItemSelected(item.work_desc)">{{ item.work_desc }}</mat-checkbox>
        <textarea
          *ngIf="isItemSelected(item)"
          placeholder="Enter notes..."
          (input)="updateNote(item, $event.target.value)"
          [value]="getItemNote(item.work_desc)"
          class="notes-field"
        ></textarea>
      </div>
    </form>

    <div style="margin-top: 1em;">
      <mat-form-field appearance="fill">
        <mat-label style="color: #424242; font-weight: 600;">Region</mat-label>
        <mat-select [(value)]="selectedRegion">
          <mat-option *ngFor="let region of regions" [value]="region.value">
            {{ region.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="actions">
      <button *ngIf="selectedRegion || customer_id == null" mat-button color="primary" (click)="save()">Save</button>
      <p *ngIf="!selectedRegion && customer_id > 0" style="margin-bottom: 0; padding: 1em;">Select Region to Save</p>
      <button mat-button color="warn" (click)="cancel()">Cancel</button>
    </div>
  </div>
  